import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { X } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';
import { toast } from 'sonner';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ProductRequestFAB = () => {
    const location = useLocation();
    const [open, setOpen] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    // Hide on admin and seller dashboard pages
    if (location.pathname.startsWith('/admin') || location.pathname.startsWith('/seller')) return null;

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        const fd = new FormData(e.target);
        try {
            const res = await fetch(`${API_URL}/product-requests`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    product_name: fd.get('product_name'),
                    brand: fd.get('brand'),
                    category: '',
                    country: fd.get('country'),
                    email: '',
                    notes: fd.get('notes'),
                    search_term: '',
                    zero_results: false,
                }),
            });
            if (res.ok) {
                toast.success('Request submitted! We will work to source this for you.');
                e.target.reset();
                setOpen(false);
            }
        } catch { toast.error('Failed to submit request'); }
        finally { setSubmitting(false); }
    };

    return (
        <>
            {/* FAB with label */}
            {!open && (
                <button
                    onClick={() => setOpen(true)}
                    className="fixed bottom-5 right-5 z-40 bg-primary text-primary-foreground rounded-full pl-4 pr-5 py-2.5 shadow-lg hover:shadow-xl transition-shadow flex items-center gap-2 text-sm font-medium"
                    aria-label="Request a biscuit"
                    data-testid="request-fab"
                >
                    <span>🍪</span>
                    <span>Request a biscuit</span>
                </button>
            )}

            {/* Panel */}
            {open && (
                <div className="fixed bottom-5 right-5 z-40 w-[320px] bg-background border rounded-xl shadow-2xl" data-testid="request-fab-panel">
                    <div className="flex items-center justify-between p-4 border-b">
                        <h3 className="font-semibold text-sm">Request a biscuit</h3>
                        <button onClick={() => setOpen(false)} className="text-muted-foreground hover:text-foreground">
                            <X className="w-4 h-4" />
                        </button>
                    </div>
                    <form onSubmit={handleSubmit} className="p-4 space-y-3">
                        <div>
                            <Input name="product_name" placeholder="Biscuit name *" required data-testid="fab-product-name" />
                        </div>
                        <div>
                            <Input name="brand" placeholder="Brand (if you know it)" />
                        </div>
                        <div>
                            <Input name="country" placeholder="Country (optional)" />
                        </div>
                        <div>
                            <Textarea name="notes" placeholder="Any other details (optional)" rows={2} />
                        </div>
                        <Button type="submit" className="w-full" size="sm" disabled={submitting}>
                            {submitting ? 'Submitting...' : 'Submit Request'}
                        </Button>
                    </form>
                </div>
            )}
        </>
    );
};

export default ProductRequestFAB;
